import { ChargeSessionCodeType } from '../../../enums';
import * as CommonFields from '../fixture/fields';

const {
  GripIcon,
  UnitCount,
  CPTCode,
  ICDCode,
  ModifierCode,
  AssesmentSelect,
  RoleSelect,
  BaseCQACodeAssessmentIcon
} = CommonFields;

const CPTCodeSection: CMxCommonApp.CodeLayerField[] = [
  //Draggable icon
  GripIcon,
  //Units input
  UnitCount,
  //Code Pill
  CPTCode,
  //Dropdown 1
  { ...AssesmentSelect },
  //Dropdown 2
  { ...RoleSelect },
  // UI treatment for assessment/role
  BaseCQACodeAssessmentIcon
];

const ICDCodeSection: CMxCommonApp.CodeLayerField[] = [
  //Draggable icon
  GripIcon,
  //Code Pill
  ICDCode,
  //Dropdown 1
  { ...AssesmentSelect },
  //Dropdown 2
  { ...RoleSelect },
  // UI treatment for assessment/role
  BaseCQACodeAssessmentIcon
];

const ModifierCodeSection: CMxCommonApp.CodeLayerField[] = [
  //Draggable icon
  GripIcon,
  //Code Pill
  ModifierCode,
  //Dropdown 1
  {
    ...AssesmentSelect,
    optionsTreePath: CommonFields.modifierAssessmentOptionsTreePath
  },
  //Dropdown 2
  { ...RoleSelect, optionsTreePath: CommonFields.modifierRoleOptionsTreePath },
  // UI treatment for assessment/role
  BaseCQACodeAssessmentIcon
];

export const CodeGradingSections = {
  CPTCodeSection,
  ICDCodeSection,
  ModifierCodeSection
};

export const defaultCQAProjectConfiguration = {
  procedure: true,
  diagnosis: true,
  modifier: true,
  assessment: true,
  role: true,
  caseEvaluationLevel: false
};

export const defaultQARule: CMxAPI.QaRule = {
  id: '1',
  source: '1',
  status: '1',
  data: {
    qa_collection_id: null,
    qa_collection_uuid: null,
    id: 1,
    guideline: null,
    sample_reason: null,
    project_configuration: defaultCQAProjectConfiguration
  }
};

export const gradeBenchPanelState: Accelerate.GradeBenchPanelState = {
  invoices: [],
  fieldDefinitions: {
    cptFields: CPTCodeSection,
    icdFields: ICDCodeSection,
    modifierFields: ModifierCodeSection
  },
  riskCategories: {
    [ChargeSessionCodeType.PROCEDURE]: {},
    [ChargeSessionCodeType.DIAGNOSIS]: {},
    [ChargeSessionCodeType.MODIFIER]: {}
  },
  qaRule: defaultQARule,
  gradingErrors: {
    addTransaction: false
  },
  cqaCodeAssessmentRiskDictionaries: {
    procedure: {
      columnNames: [],
      rows: []
    },
    diagnosis: {
      columnNames: [],
      rows: []
    },
    modifier: {
      columnNames: [],
      rows: []
    }
  },
  associatedWorkitems: [],
  workerInfo: null,
  activity: [],
  looseSpans: [],
  codeDescriptions: {},
  rubricVersion: null,
  caseAttributes: [],
  attributesFetched: false,
  validationResult: null,
  resolverValidationErrors: null,
  caseLevelComplete: null,
  pendingAutosaves: {},
  attributeLatestRequestId: {}
};
